import {useGetAutoDeliveryDetailsExtendedDcx} from '@/api/consumerApi';
import {isAutoDeliveryDcxOrderExpected} from '@/consts/icc/iccAutoDeliveryStatusTypes';

const useAutoDeliveryDcxDetails = () => {
    const {
        data: {autoDelivery, order},
    } = useGetAutoDeliveryDetailsExtendedDcx();
    const {status: orderStatus} = order;

    const isOrderStatusExpected = isAutoDeliveryDcxOrderExpected(orderStatus);

    return {autoDelivery, order, isOrderStatusExpected};
};

export default useAutoDeliveryDcxDetails;
